// extracted by mini-css-extract-plugin
module.exports =  {"highlight":"qJdNc_g","price-wrapper":"BDRTuqv","priceWrapper":"BDRTuqv"};